<template>
  <div id="app" class="row vert-offset-top-1">
    <div class="row justify-content-center">
      <div class="col s12 m10 l7 offset-m1 offset-l2">
        <h3 class="grey-text text-darken-3" v-if="submit_booking == false"></h3>
        <div id="card" class="card col s12 vert-offset-top-half z-depth-3">
          <div class="col s12 no-padding" v-if="submit_booking == false">
            <div class="col s12 no-padding">
              <div
                class="card-title center padding-top-half padding-bottom-half border-bottom-1 grey-border border-lighten-2"
              >
                <h5 class="font-bold ">Summary</h5>
              </div>
            </div>
            <div class="col s12 ">
              <div v-if="stateHasSelectedMobile" class="col s12 no-padding">
                <div
                  class="col s12 padding-top-half padding-top-half padding-bottom-half font-16 left-align border-bottom-1 grey-border border-lighten-3 vert-offset-bottom-1"
                >
                  <div class="col s3 grey-text text-darken-2">
                    Mobile Number
                  </div>
                  <div class="col s7 deep-orange-text darken-2">
                    {{ stateSelectedMobile }}
                  </div>
                  <div class="col s2 no-padding">
                    <a
                      @click.prevent="editMobile"
                      class="btn btn-small  orange darken-1  white-text right"
                    >
                      <i class="material-icons">edit</i>
                    </a>
                  </div>
                </div>

                <div class="col s12 no-padding" v-if="stateHasCreatePatient">
                  <div
                    class="col s12 padding-top-half padding-top-half padding-bottom-half font-16 left-align border-bottom-1 grey-border border-lighten-3 vert-offset-bottom-1"
                  >
                    <div class="col s10 grey-text text-darken-2">
                      <h6>Detail</h6>
                    </div>
                    <div class="col s2 no-padding">
                      <a
                        @click.prevent="editDetails"
                        class="btn btn-small  orange darken-1  white-text right"
                      >
                        <i class="material-icons">edit</i>
                      </a>
                    </div>
                  </div>
                  <div
                    class="col s12 padding-bottom-1 border-bottom-1 grey-border border-lighten-3"
                  >
                    <div class="col s12 no-padding vert-offset-top-half">
                      <div class="col s3 grey-text text-darken-2">
                        Name
                      </div>
                      <div
                        class="col s7 deep-orange-text darken-2 border-bottom-1 grey-border border-lighten-4 left-align"
                      >
                        {{ stateSelectedFullName }}
                      </div>
                    </div>
                    <div class="col s12 no-padding vert-offset-top-half">
                      <div class="col s3 grey-text text-darken-2">
                        Email
                      </div>
                      <div
                        class="col s7 deep-orange-text darken-2 border-bottom-1 grey-border border-lighten-4 left-align"
                      >
                        {{ stateSelectedEmail }}
                      </div>
                    </div>
                    <div class="col s12 no-padding vert-offset-top-half">
                      <div class="col s3 grey-text text-darken-2">
                        Nationality
                      </div>
                      <div
                        class="col s7 deep-orange-text darken-2 border-bottom-1 grey-border border-lighten-4 left-align"
                      >
                        {{ stateSelectedNationality.title }}
                      </div>
                    </div>
                    <div class="col s12 no-padding vert-offset-top-half">
                      <div class="col s3 grey-text text-darken-2">
                        ID/Passport Number
                      </div>
                      <div
                        class="col s7 deep-orange-text darken-2 border-bottom-1 grey-border border-lighten-4 left-align"
                      >
                        {{ stateSelectedIdNumber }}
                      </div>
                    </div>
                    <div class="col s12 no-padding vert-offset-top-half">
                      <div class="col s3 grey-text text-darken-2">
                        Gender
                      </div>
                      <div
                        class="col s7 deep-orange-text darken-2 border-bottom-1 grey-border border-lighten-4 left-align"
                      >   <ul class="vert-offset-top-0">
                        <li>
                          {{ stateSelectedGender.title }}
                        </li>
                      </ul>
                      </div>
                    </div>
                    <div class="col s12 no-padding vert-offset-top-half">
                      <div class="col s3 grey-text text-darken-2">
                        Sexual Orientation
                      </div>
                      <div
                              class="col s7 deep-orange-text darken-2 border-bottom-1 grey-border border-lighten-4 left-align"
                      >
                        <ul class="vert-offset-top-0">
                          <li>
                            {{ stateSelectedSexualOrientation.title }}
                          </li>
                        </ul>

                      </div>
                    </div>
                    <div class="col s12 no-padding vert-offset-top-half">
                      <div class="col s3 grey-text text-darken-2">
                        Date of Birth
                      </div>
                      <div
                        class="col s7 deep-orange-text darken-2 border-bottom-1 grey-border border-lighten-4 left-align"
                      >
                        {{ stateSelectedDob }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  stateHasSelectedCenter /*&& stateHasSelectedLocation*/ /*&& stateHasSelectedDistrict*/
                "
                class="col s12 no-padding vert-offset-top-1"
              >
                <div class="col s12 no-padding">
                  <div
                    class="col s12 padding-top-half padding-top-half padding-bottom-half font-16 left-align border-bottom-1 grey-border border-lighten-3 vert-offset-bottom-1"
                  >
                    <div class="col s3 grey-text text-darken-2">
                      Assessment Center
                    </div>
                    <div class="col s7 deep-orange-text darken-2">
                      {{ stateSelectedCenter.title }}
                      <!--{{stateSelectedDistrict.title }}--><!--, {{ stateSelectedLocation.title }}-->
                    </div>
                    <div class="col s2 no-padding">
                      <a
                        @click.prevent="editCenter"
                        class="btn btn-small  orange darken-1  white-text right"
                      >
                        <i class="material-icons">edit</i>
                      </a>
                    </div>
                  </div>

                  <div
                    v-if="stateHasSelectedDate"
                    class="col s12 padding-top-half padding-top-half padding-bottom-half font-16 left-align border-bottom-1 grey-border border-lighten-3 vert-offset-bottom-1"
                  >
                    <div class="col s3 grey-text text-darken-2">
                      Date & Time
                    </div>
                    <div class="col s7 deep-orange-text darken-2">
                      {{ stateSelectedDate }}
                    </div>
                    <div class="col s2 no-padding">
                      <a
                        @click.prevent="editSchedule"
                        class="btn btn-small  orange darken-1 white-text right"
                      >
                        <i class="material-icons">edit</i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="stateHasSelectedServices" class="col s12 no-padding">
                <div
                  class="col s12 padding-top-half padding-top-half padding-bottom-half font-16 left-align border-bottom-1 grey-border border-lighten-3 vert-offset-bottom-1"
                >
                  <div class="col s3 grey-text text-darken-2">
                    Reason(s) for visit
                  </div>
                  <div class="col s7 deep-orange-text darken-2">
                    <ul class="vert-offset-top-0">
                      <li
                        v-for="(item, index) in stateSelectedServices"
                        :key="index"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                  <div class="col s2 no-padding">
                    <a
                      @click.prevent="editService"
                      class="btn btn-small orange darken-1  white-text right"
                    >
                      <i class="material-icons">edit</i>
                    </a>
                  </div>
                </div>
              </div>

              <div class="col s12 no-padding">
                <div
                  class="col s12 padding-top-half padding-top-half padding-bottom-half font-16 left-align border-bottom-1 grey-border border-lighten-3 vert-offset-bottom-1"
                >
                  <div class="col s5 grey-text text-darken-2">
                    Any Additional Information you would like us to know?
                  </div>
                  <div class="col s7 deep-orange-text darken-2">
                    <input type="text" v-model="info" placeholder="info" />
                  </div>
                  <div class="col s2 no-padding"></div>
                </div>
              </div>

              <div class="col s3  padding-bottom-1 padding-top-1 ">
                <button
                  type="submit"
                  @click="confirmCancelBooking"
                  class="btn btn-small orange darken-1 white-text col s12"
                >
                  Cancel
                </button>
              </div>
              <div class="col s3 offset-s6  padding-bottom-1 padding-top-1 ">
                <button
                  type="submit"
                  @click="confirmCreateBooking"
                  class="btn btn-small orange darken-1  white-text col s12"
                >
                  Book
                </button>
              </div>
            </div>
          </div>

          <div
            class="row vert-offset-top-half vert-offset-bottom-half"
            v-if="submit_booking == true"
          >
            <div class="s12 padding-bottom-1 padding-top-1">
              <div
                class="col s10 offset-s1 m8 offset-m2 l6 offset-l3 padding-top-1 padding-bottom-1 vert-offset-top-2 center"
              >
                <h5>
                  Thank you for submitting your booking,Please wait for response
                  from the specified center!
                </h5>
                <div
                  class="col s12 padding-top-half font-12 vert-offset-top-1 border-top-1 grey-border border-lighten-2"
                >
                  You will be redirected in
                  <span class="font-bold">{{ timer }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/http-common";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import { bus } from "../main";
export default {
  name: "Book",
  components: {},
  data() {
    return {
      districts: [],
      items: [],
      timer: 10,
      submit_booking: false,
      info: ""
    };
  },
  methods: {
    goto() {
      this.$router.push("/");
    },
    editMobile() {
      this.$router.push("/usercontactdetails");
    },
    editDetails() {
      this.$router.push("/patientdetails");
    },
    editCenter() {
      this.$router.push("/");
    },
    editService() {
      this.$router.push("/reason");
    },
    editSchedule() {
      this.$router.push("/schedule");
    },
    editLocation() {
      this.$router.push("/");
    },

    mustRedirectHome: function() {
      if (
        !this
          .stateHasSelectedCenter /*|| !this.stateHasSelectedDistrict*/ /*|| ! this.stateHasSelectedLocation*/ ||
        !this.stateHasSelectedMobile ||
        !this.stateHasSelectedDate ||
        !this.stateHasSelectedServices ||
        (this.stateHasCreatePatient &&
          (!this.stateHasSelectedEmail ||
            !this.stateHasSelectedFullName ||
            !this.stateHasSelectedIdNumber ||
            !this.stateHasSelectedNationality ||
            !this.stateHasSelectedGender ||
             !this.stateHasSelectedSexualOrientation ||
            !this.stateHasSelecteDob))
      ) {
        return true;
      }
      return false;
    },
    saveBooking() {
      this.services = new Array();
      let _i;
      for (_i = 0; _i < this.stateSelectedServices.length; _i++) {
        this.services.push(this.stateSelectedServices[_i].key);
      }

        this.$store.dispatch("START_PROCESSING");
      return new Promise(resolve => {
        http({
          url: "/api/booking/save",
          data: {
            mobile: this.stateSelectedMobile,
            date: this.stateSelectedDate,
            center: this.stateSelectedCenter.value,
            /* district: this.stateSelectedDistrict.value,*/
            nationality:
              typeof this.stateSelectedNationality !== "undefined" &&
              this.stateSelectedNationality !== null
                ? this.stateSelectedNationality.value
                : null,
            /*location: this.stateSelectedLocation.value,*/
            services: this.services,
            email: this.stateSelectedEmail,
            name: this.stateSelectedFullName,
            idnumber: this.stateSelectedIdNumber,
            dob: this.stateSelectedDob,
            yob:  new Date(this.stateSelectedDob).getFullYear(),
            gender:
            typeof this.stateSelectedGender !== "undefined" &&
            this.stateSelectedGender !== null
            ? this.stateSelectedGender.value
            :  null,
            sexualorientation:
            typeof this.stateSelectedSexualOrientation !== "undefined" &&
            this.stateSelectedSexualOrientation !== null
            ? this.stateSelectedSexualOrientation.value
            : null,
            info: this.info
          },
          method: "POST",
          timeout: 30000
        })
          .then(response => {
            this.$store.dispatch("GET_MESSAGES", ["Success, Booking sent"]);
            this.$store.dispatch("STOP_PROCESSING");
            this.submit_booking = true;
            this.$store.dispatch("SET_SELECTED_SERVICES", null);
            /*  this.$store.dispatch('SET_SELECTED_LOCATION', null);*/
            /* this.$store.dispatch('SET_SELECTED_DISTRICT', null);*/
            this.$store.dispatch("SET_NATIONALITY", null);
            this.$store.dispatch("SET_SELECTED_CENTER", null);
            this.$store.dispatch("SET_DATE", null);
            this.$store.dispatch("SET_NAME", null);
            this.$store.dispatch("SET_ID", null);
            this.$store.dispatch("SET_EMAIL", null);
            this.$store.dispatch("SET_GENDER", null);
            this.$store.dispatch("SET_SEXUAL_ORIENTATION", null);
            this.$store.dispatch("SET_DOB", null);
            this.$store.dispatch("SET_MOBILE", null);
            this.$store.dispatch("SET_CREATE_PATIENT", null);
            this.prepareReload();
            resolve(response);
          })
          .catch(response => {
            this.$store.dispatch("STOP_PROCESSING");
            this.$store.dispatch("GET_MESSAGES", response.data.message);
            resolve(response);
          });
      });
    },
    prepareReload() {
      setTimeout(() => {
        this.$store.dispatch("START_PROCESSING");
        this.$router.push("/");
        this.$store.dispatch("STOP_PROCESSING");
      }, 10000);
      setInterval(() => this.timer--, 1000);
    },
    confirmCreateBooking: function() {
      console.log("Event Triggered: createBooking");
      this.$store.dispatch("SET_ACTION", "createBooking");
    },
    confirmCancelBooking: function() {
      console.log("Event Triggered: cancelBooking");
      this.$store.dispatch("SET_ACTION", "cancelBooking");
    },
    cancelBooking() {
      console.log("Form will be canceled");
      this.$store.dispatch("SET_SELECTED_SERVICES", null);
      this.$store.dispatch("SET_SELECTED_LOCATION", null);
      this.$store.dispatch("SET_SELECTED_DISTRICT", null);
      this.$store.dispatch("SET_SELECTED_CENTER", null);
      this.$store.dispatch("SET_NATIONALITY", null);
      this.$store.dispatch("SET_DATE", null);
      this.$store.dispatch("SET_NAME", null);
      this.$store.dispatch("SET_ID", null);
      this.$store.dispatch("SET_EMAIL", null);
      this.$store.dispatch("SET_GENDER", null);
      this.$store.dispatch("SET_DOB", null);
      this.$store.dispatch("SET_MOBILE", null);
      this.$store.dispatch("SET_CREATE_PATIENT", null);
      this.$store.dispatch("GET_MESSAGES", ["Cancelled Booking "]);
      this.$router.push("/");
    }
  },
  created() {
    bus.$on("confirmAction", _data => {
      if (_data == "createBooking") {
        this.saveBooking();
      }
      console.log("ACTION: " + _data);
      this.$store.dispatch("SET_ACTION", "");
    });
    bus.$on("confirmAction", _data => {
      if (_data == "cancelBooking") {
        this.cancelBooking();
      }
      console.log("ACTION: " + _data);
      this.$store.dispatch("SET_ACTION", "");
    });


  },
  beforeCreate() {
    this.$store.commit("initialiseStore");
  },
  computed: {
    ...mapState({
      stateSelectedFullName: state => state.name,
      stateSelectedIdNumber: state => state.id,
      stateSelectedEmail: state => state.email,
      stateSelectedDob: state => state.dob,
      stateSelectedYob: state => state.yob,
      stateSelectedGender: state => state.gender,
      stateSelectedSexualOrientation: state => state.sexual_orientation,
      stateCreatePatient: state => state.createPatient,
      stateSelectedMobile: state => state.mobile,
      /* stateSelectedDistrict:state =>state.selectedDistrict,*/
      stateSelectedNationality: state => state.nationality,
      stateSelectedCenter: state => state.selectedCenter,
      stateSelectedLocation: state => state.selectedLocation,
      stateSelectedServices: state => state.selectedServices,
      stateSelectedDate: state => state.date
    }),
    stateHasCreatePatient: function() {
      return (
        typeof this.stateCreatePatient !== "undefined" &&
        this.stateCreatePatient !== null &&
        this.stateCreatePatient === true
      );
    },
    stateHasSelectedFullName: function() {
      return (
        typeof this.stateSelectedFullName !== "undefined" &&
        this.stateSelectedFullName !== null
      );
    },
    stateHasSelectedEmail: function() {
      return (
        typeof this.stateSelectedEmail !== "undefined" &&
        this.stateSelectedEmail !== null
      );
    },
    stateHasSelectedIdNumber: function() {
      return (
        typeof this.stateSelectedIdNumber !== "undefined" &&
        this.stateSelectedIdNumber !== null
      );
    },
    stateHasSelectedGender: function() {
      return (
        typeof this.stateSelectedGender !== "undefined" &&
        this.stateSelectedGender !== null
      );
    },
    stateHasSelectedSexualOrientation: function() {
      return (
              typeof this.stateSelectedSexualOrientation !== "undefined" &&
              this.stateSelectedSexualOrientation !== null
      );
    },
    stateHasSelectedDob: function() {
      return (
        typeof this.stateSelectedDob !== "undefined" &&
        this.stateSelectedDob !== null
      );
    },
      stateHasSelectedYob: function() {
          return (
              typeof this.stateSelectedYob !== "undefined" &&
              this.stateSelectedYob !== null
          );
      },
    stateHasSelectedDate: function() {
      return (
        typeof this.stateSelectedDate !== "undefined" &&
        this.stateSelectedDate !== null
      );
    },
    stateHasSelectedDistrict: function() {
      return (
        typeof this.stateSelectedDistrict !== "undefined" &&
        this.stateSelectedDistrict !== null
      );
    },
    stateHasSelectedLocation: function() {
      return (
        typeof this.stateSelectedLocation !== "undefined" &&
        this.stateSelectedLocation !== null
      );
    },
    stateHasSelectedCenter: function() {
      return (
        typeof this.stateSelectedCenter !== "undefined" &&
        this.stateSelectedCenter !== null
      );
    },
    stateHasSelectedNationality: function() {
      return (
        typeof this.stateSelectedNationality !== "undefined" &&
        this.stateSelectedNationality !== null
      );
    },
    stateHasSelectedMobile: function() {
      return (
        typeof this.stateSelectedMobile !== "undefined" &&
        this.stateSelectedMobile !== null
      );
    },
    stateHasSelectedServices: function() {
      return (
        typeof this.stateSelectedServices !== "undefined" &&
        this.stateSelectedServices !== null
      );
    },
      year: function() {
        return( this.stateHasSelectedDob().getFullYear()
          )

      },
    ...mapGetters([
      "getemail",
      "getname",
      "getDateofbirth",
      "getYearofbirth",
      "getidnumber",
      "getgender",
      "getservice",
      "getdate",
      "getmobile",
      "getselectorientation",
      "centers",
      "getnationality"
    ])
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-kerning: normal;
}
</style>
